import { StyleSheet, Platform } from 'react-native';

const styleBody = Platform.select({
  ios: { flex: 1 },
  android: { minHeight: '100%', flex: 1 },
});

export const styles = StyleSheet.create({
  modalRootStyles: {
    alignItems: 'stretch',
  },
  body: {
    ...styleBody,
    justifyContent: 'center',
  },
  modalContainer: {
    ...Platform.select({
      ios: {},
      android: {},
      default: {
        maxWidth: 500,
        //width: '100%',
      },
    }),
    marginTop: 5,
    marginBottom: 5,
    padding: 15,
    paddingHorizontal: 15,
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    flex: 1,
  },
  title: {
    marginBottom: 18,
  },
  text: {
    textAlign: 'left',
    fontWeight: '400',
    fontSize: 16,
    lineHeight: 19,
    color: '#666666',
  },
  btn: {
    marginTop: 28,
    marginBottom: 15,
    width: '100%',
  },
});
